import { Box, Card, Icon, InlineStack, Tabs } from '@shopify/polaris';
import { ChevronLeftMinor, ChevronRightMinor } from '@shopify/polaris-icons';
import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';

const TopTabs = (props: {
    categoryAndAttributesSettings: any;
    isNewTemplate: boolean;
    attributesLoader: boolean;
    shopifyAttributesLoader: boolean;
}) => {
    const { t } = useTranslation();
    const show_attributes_option = !!props?.categoryAndAttributesSettings?.category_settings?.primary_category && !props?.attributesLoader && !props?.shopifyAttributesLoader && (props.isNewTemplate ? !!props?.categoryAndAttributesSettings?.category_settings?.product_type?.[0] : true)

    const items = [
        {
            id: 'template_name',
            name: 'Template Name',
            content: t('Template Name'),
        },
        {
            id: 'fullfilment_type',
            name: 'Fulfilment Type',
            content: t('Fulfilment Type'),
        },
        {
            id: 'category_settings',
            name: 'Category Settings',
            content: t('Category Settings'),
        },
        ...show_attributes_option ? [{
            id: 'attributes_mapping',
            name: 'Attributes',
            content: t('Attributes'),
        }] : [],
        {
            id: 'inventory_settings',
            name: 'Inventory Settings',
            content: t('Inventory Settings'),
        },
        {
            id: 'price_settings',
            name: 'Price Settings',
            content: t('Price Settings'),
        },
        {
            id: 'product_settings',
            name: 'Product Settings',
            content: t('Product Settings'),
        },
        {
            id: 'filter_products',
            name: 'Filter Products',
            content: t('Filter Products'),
        },
    ]

    const scrollToElement = (element: any, offsetTop: number = 150) => {
        let y = element?.getBoundingClientRect()?.top + window.pageYOffset - offsetTop;
        window.scrollTo({ top: y, behavior: 'smooth' });
    }

    const { windowWidth } = useWindowSize()

    const [selectedTab, setSelectedTab] = useState(0);
    const tabsListRef = useRef<HTMLUListElement>(null);

    const tabWidth = 150;
    const [showLeftButton, setShowLeftButton] = useState<boolean>(false);
    const [showRightButton, setShowRightButton] = useState<boolean>(false);

    const getActiveSection = (): number => {
        const sections = items.map((item: any) => item.id);
        let visible: number = 0
        sections.forEach((id: string, idx: number) => {
            let section = document.querySelector('#' + id)
            if (!section) return;
            const sectionTop = section.getBoundingClientRect().top;
            if (sectionTop <= 150)
                visible = idx
        });
        return visible
    }

    const scrollToTabCenter = (tabIndex: number) => {
        const container = tabsListRef.current;
        if (container) {
            const tabElement = container.children[tabIndex] as HTMLLIElement;
            const containerWidth = container.offsetWidth;
            const tabWidth = tabElement.offsetWidth;
            const tabLeftOffset = tabElement.offsetLeft;

            const scrollLeft = tabLeftOffset - (containerWidth - tabWidth) / 2;
            container.scrollTo({ left: scrollLeft, behavior: 'smooth' });
        }
    };

    const scrollByTabWidth = (delta: number) => {
        const container = tabsListRef.current;
        if (container && tabWidth > 0) {
            const currentScrollLeft = container.scrollLeft;
            const newScrollLeft = currentScrollLeft + delta * tabWidth;
            container.scrollTo({ left: newScrollLeft, behavior: 'smooth' });
        }
    };

    const scrollRight = () => {
        scrollByTabWidth(1); // Scroll one tab width to the right
    };

    const scrollLeft = () => {
        scrollByTabWidth(-1); // Scroll one tab width to the left
    };

    useEffect(() => {
        const container = tabsListRef.current;
        if (container) {
            const tabElement = container.querySelector('.Polaris-Tabs__TabContainer') as HTMLDivElement;
            if (tabElement) {
                const handleScroll = () => {
                    const { scrollLeft, scrollWidth, clientWidth } = container;
                    setShowLeftButton(scrollLeft > 0);
                    setShowRightButton(scrollLeft + clientWidth < scrollWidth);
                };

                container.addEventListener('scroll', handleScroll);
                handleScroll();

                return () => {
                    container.removeEventListener('scroll', handleScroll);
                };
            }
        }
    }, [windowWidth]);

    useEffect(() => {
        const tabIndex = getActiveSection()
        setSelectedTab(tabIndex);
        scrollToTabCenter(tabIndex)
    }, [useScrollY()])

    return (
        <div className='Custom-Sticky-tabs Custom-Polaris-Box'>
            <Box paddingInline='0' paddingBlockStart="0" paddingBlockEnd="0" background='bg-surface' borderRadius='200' borderWidth='025' borderColor='border' borderStyle='solid' shadow='100'>
                <div className='Polaris-Box custom-polaris--tab_box'>
                    <InlineStack wrap={false} blockAlign='center' gap="0">
                        {showLeftButton && <div className='custom-tab--icon' onClick={() => { scrollLeft() }}>
                            <Icon
                                source={ChevronLeftMinor}
                                tone="base"
                            />
                        </div>}
                        <ul className='Polaris-Tabs Polaris-Tabs--fillSpace' ref={tabsListRef}>
                            {
                                items.map((item: any, idx: any) => {
                                    return (
                                        <li className='Polaris-Tabs__TabContainer' key={idx} id={'selectedtab' + idx}>
                                            <button
                                                onClick={(e) => {
                                                    const { id, ...rest } = items?.[idx];
                                                    setSelectedTab(idx)
                                                    scrollToElement(document.querySelector('#' + id), 100)
                                                    scrollToTabCenter(idx)
                                                }}
                                                className={`Polaris-Tabs__Tab ${selectedTab == idx ? 'Polaris-Tabs__Tab--active' : ''}`}>
                                                <span className='Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium'>{item.content}</span>
                                            </button>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                        {showRightButton && <div className='custom-tab--icon' onClick={() => { scrollRight() }}>
                            <Icon
                                source={ChevronRightMinor}
                                tone="base"
                            />
                        </div>}
                    </InlineStack>
                </div>
            </Box>
            {/* <Card padding={'200'}>
                <Tabs
                    tabs={items()}
                    selected={selectedTab}
                    onSelect={(selectedTabIndex) => {

                        const { id, ...rest } = items()?.[selectedTabIndex];
                        setSelectedTab(selectedTabIndex)
                        scrollToElement(document.querySelector('#' + id), 100)
                    }}
                />
            </Card> */}
        </div>
    )
}

export default TopTabs;

function useScrollY() {
    const [scrollPosition, setScrollPosition] = useState(0);

    useEffect(() => {
        function handleScroll() {
            const position = window.pageYOffset;
            setScrollPosition(position);
        }

        window.addEventListener('scrollend', handleScroll);

        return () => {
            window.removeEventListener('scrollend', handleScroll);
        };
    }, []);

    return scrollPosition;
}

const useWindowSize = () => {
    const [windowSize, setWindowSize] = useState({
        windowWidth: window.innerWidth,
        windowHeight: window.innerHeight,
    });

    useEffect(() => {
        const updateWindowSize = () => {
            setWindowSize({
                windowWidth: window.innerWidth,
                windowHeight: window.innerHeight,
            });
        };

        window.addEventListener('resize', updateWindowSize);

        updateWindowSize();

        return () => {
            window.removeEventListener('resize', updateWindowSize);
        };
    }, []);

    return windowSize;
};
